import { ActionTree } from "vuex";
import { IPagination, RootState } from "@/types";
import { ISkill, ISkillListRequest, SkillState } from "@/types/skill";
import CustomRequest from "../customRequest";

const actions: ActionTree<SkillState, RootState> = {
  async get({ commit }, id: number) {
    await CustomRequest.get<IPagination<ISkill>>({
      uri: `/skill/${id}`,
      commit,
      target: "single",
    });
  },

  async getList({ commit }, params: ISkillListRequest) {
    await CustomRequest.get<IPagination<ISkill>>({
      uri: "/skill",
      params,
      commit,
      target: "pagination",
    });
  },
};

export default actions;
